import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import {
  Home, Users, Briefcase, Clock, FileText, Bell, Settings, LogOut, Menu, X,
  ChevronRight, ChevronDown, Plus, CheckCircle, AlertCircle, MapPin, Calendar, User,
  ClipboardList, BarChart3, Play, Square, RefreshCw, Search, Filter, Eye,
  Truck, Camera, Upload, Image, Wrench, Shield, FileImage, Trash2, Save,
  Building2, Sliders, Key, MessageSquare, Send, Car, Fuel, Video, HelpCircle,
  ChevronLeft, Download, Edit3, Check, ArrowLeft, Edit2, UserCheck, Archive, Receipt, BookOpen
} from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../App";
import { Badge, Button, Card, Input, Modal, Select, Spinner, Textarea, FileUploadInput } from "../../shared/ui";
import { DatePicker, DateTimePicker } from "../DateTimePicker";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;


const EquipmentScheduleSection = ({ schedule, onChange }) => {
  const [newItem, setNewItem] = useState({
    equipment_name: "",
    start_date: "",
    end_date: "",
    quantity: 1,
    notes: ""
  });

  const addEquipment = () => {
    if (newItem.equipment_name && newItem.start_date) {
      onChange([...schedule, { ...newItem, id: Date.now() }]);
      setNewItem({ equipment_name: "", start_date: "", end_date: "", quantity: 1, notes: "" });
    }
  };

  const removeEquipment = (id) => {
    onChange(schedule.filter(item => item.id !== id));
  };

  return (
    <div className="p-4 bg-amber-50 border-2 border-amber-200 rounded-lg space-y-4">
      <h4 className="font-bold uppercase text-amber-800 flex items-center gap-2">
        <Truck className="w-5 h-5" />
        Equipment Schedule
      </h4>
      
      <div className="grid md:grid-cols-2 gap-4">
        <Input
          label="Equipment Name"
          value={newItem.equipment_name}
          onChange={(e) => setNewItem({...newItem, equipment_name: e.target.value})}
          placeholder="e.g., 25t Franna Crane"
        />
        <Input
          label="Quantity"
          type="number"
          min="1"
          value={newItem.quantity}
          onChange={(e) => setNewItem({...newItem, quantity: parseInt(e.target.value) || 1})}
        />
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <DatePicker
          label="Start Date"
          value={newItem.start_date}
          onChange={(v) => setNewItem({...newItem, start_date: v})}
          testId="equipment-schedule-start"
        />
        <DatePicker
          label="End Date (optional)"
          value={newItem.end_date}
          onChange={(v) => setNewItem({...newItem, end_date: v})}
          minDate={newItem.start_date ? new Date(newItem.start_date) : undefined}
          testId="equipment-schedule-end"
        />
      </div>
      <Input
        label="Notes (optional)"
        value={newItem.notes}
        onChange={(e) => setNewItem({...newItem, notes: e.target.value})}
        placeholder="e.g., For steel beam installation"
      />
      <Button type="button" variant="outline" size="sm" onClick={addEquipment}>
        <Plus className="w-4 h-4 mr-2" />
        Add Equipment
      </Button>

      {schedule.length > 0 && (
        <div className="space-y-2 mt-4 pt-4 border-t border-amber-200">
          <p className="text-sm font-semibold text-amber-800">Scheduled Equipment:</p>
          {schedule.map((item, idx) => (
            <div key={item.id || idx} className="flex items-center justify-between bg-white p-3 rounded border">
              <div>
                <p className="font-semibold">{item.quantity}x {item.equipment_name}</p>
                <p className="text-sm text-slate-500">
                  {item.start_date} {item.end_date ? `to ${item.end_date}` : '(single day)'}
                </p>
                {item.notes && <p className="text-xs text-slate-400">{item.notes}</p>}
              </div>
              <button type="button" onClick={() => removeEquipment(item.id || idx)} className="text-red-500 hover:text-red-700 p-2">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// SWMS Sign View (for workers to read and sign)

export default EquipmentScheduleSection;
